import { FilterOption } from '../../../components/_WMS/FilterComponent'

export const filterOptions: FilterOption[] = [
  {
    order: 1,
    key: 'webhookURL',
    label: 'URL',
    type: 'text'
  },
  {
    order: 2,
    key: 'active',
    label: 'Activo',
    type: 'precreated'
  },
  {
    order: 3,
    key: 'webhookEventsIds',
    label: 'Tipo Notificación',
    type: 'precreated',
    canBeRepeated: true
  }
]